import React from 'react';

import { TableComponent } from 'commons/components/Table';
import { STOProcessedItem } from 'commons/types';

import { STOReceiveSummaryPageStyle as S } from '../STOReceiveSummaryPage.style';

import { summaryTableConfig } from './configs';

interface ISTOBinListProps {
  receiveActual: STOProcessedItem[];
}

export const STOReceiveBinList: React.FC<ISTOBinListProps> = ({
  receiveActual,
}) => {
  return (
    <S.ItemContentWrapper container>
      <TableComponent
        data={receiveActual || []}
        config={summaryTableConfig}
        additionalTableConfig={{ bodyFontSize: '12px' }}
      />
    </S.ItemContentWrapper>
  );
};
